<template>
  <v-container>
    <v-dialog fullscreen v-model="waiting_dialog">
      <div class="text-center">
        <v-overlay :value="overlay">
          <v-progress-circular
            :width="3"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-dialog>
    <!-- Service Start -->
    <div
      v-if="authenticated && rdv_demands.length == 0"
      class="container-fluid wow fadeInUp"
      data-wow-delay="0.1s"
    >
      <!-- my demands -->
    </div>
    <div
      v-if="authenticated"
      class="container-fluid wow fadeInUp"
      data-wow-delay="0.1s"
    >
      <div class="container">
        <div
          class="section-title text-center position-relative pb-3 mx-auto"
          style=""
        >
          <h3
            v-if="rdv_demands.length != 0"
            class="blue-grey--text darken-1 text-center pb-4 m-3"
          >
            {{ $t("wait_rdv") }}
          </h3>

          <h3
            v-if="rdv_demands.length == 0"
            class="blue-grey--text darken-1 text-center pb-4 m-3"
          >
            {{ $t("no_demande") }}
          </h3>
        </div>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :timeout="2000"
          :top="true"
          style="z-index: 50000"
        >
          {{ snackbar_text }}
        </v-snackbar>
        <v-row class="mb-4">
          <v-col md="12" v-for="item in rdv_demands" :key="item.code_demande">
            <v-card elevation="2" class="mb-2">
              <v-card-title
                class="text-left text-white"
                :style="
                  'background-color:' + getColor(item.status_demande) + ''
                "
              >
                <v-row>
                  <v-col v-if="item.date_heure_rdv == null" md="12" cols="12">
                    {{ $t("take_rdv") }}

                    <v-icon
                      v-if="item.date_heure_rdv == null"
                      size="25"
                      color="warning"
                      class="m-1"
                      style="
                        background-color: white;
                        border: solid 2px white;
                        padding: 3px;
                        border-radius: 50px;
                        box-shadow: 1px 2px 2px black;
                      "
                      @click="(can_get_rdv = true), (current_item = item)"
                    >
                      mdi-calendar
                    </v-icon>
                  </v-col>
                  <v-col
                    v-if="item.date_heure_rdv != null"
                    md="12"
                    class="text-left"
                    cols="12"
                  >
                    <v-icon color="white"> mdi-timer-sand </v-icon>
                    {{ $t("rdv_at") }} : {{ formatDate(item.date_heure_rdv) }} 
                  </v-col>
                </v-row>
              </v-card-title>

              <v-card-text color="grey">
                <v-card-subtitle>
                  <v-row>
                    <v-col md="12" cols="12">
                      <v-col
                        style="color: #595959; font-size: 16px"
                        class="text-left date"
                        md="12"
                        cols="12"
                      >
                        <span class="h6"> {{ $t("lastName") }} </span> :
                        {{ item.nom + " " + item.prenom }} <br />

                        <span class="h6"> {{ $t("place_rdv") }} </span> :

                        {{ item.designation + " de " + item.pays }} <br />

                        <span class="h6"> {{ $t("visa_type") }} </span> :
                        {{ item.type_visas }}
                      </v-col>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div class="text-center">
          <v-dialog
            width="1000"
            hide-overlay
            transition="dialog-bottom-transition"
            persistent
            content-class="custimize-dialog"
            style="z-index: 2000"
            v-model="can_get_rdv"
          >
            <v-card>
              <v-card-title class="mx-auto grey lighten-2">
                <v-btn
                  icon
                  class="m-2"
                  small
                  color="primary"
                  text
                  @click="can_get_rdv = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <h4 class="blue-grey--text mx-auto darken-1 text-center m-2">
                  {{ $t("requet_rdv") }}
                </h4>
              </v-card-title>

              <v-card-text>
                <v-col class="p-3" cols="12" sm="12">
                  <div>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          @blur="$v.date.$touch()"
                          v-model="date"
                          :label="$t('date_rdv')"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="dateErrors"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="orange lighten-1"
                        :allowed-dates="allowedDates"
                        is-range
                        v-model="date"
                        :active-picker.sync="activePicker"
                        :min="new Date(new Date()).toISOString().substr(0, 10)"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col class="p-3" cols="12" sm="12">
                  <v-autocomplete
                    v-model="hours"
                    required
                    filled
                    item-text="name"
                    item-value="value"
                    @blur="$v.hours.$touch()"
                    :items="available_hours"
                    :label="$t('heur_dispo')"
                    :error-messages="hoursErrors"
                  ></v-autocomplete>
                </v-col>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :loading="isLoading"
                  color="primary"
                  :disabled="this.$v.hours.$invalid || this.$v.date.$invalid"
                  @click="takeRdv"
                >
                  {{ $t("valide_btn") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <!-- Service End -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import i18n from "../plugins/i18n";
import moment from "moment";
import { required } from "vuelidate/lib/validators";

export default {
  name: "Takerdv",
  components: {},
  mixins: [validationMixin],
  validations: {
    hours: { required },
    date: { required },
  },
  data() {
    return {
      overlay: true,
      waiting_dialog: true,
      snackbar: false,
      snackbarColor: "default",
      snackbar_text: "",
      isLoading: false,
      available_hours: [{ name: "15h", value: "15h" }],
      available_day: [],
      hours: null,
      current_item: null,
      can_get_rdv: false,
      service_value: null,
      tab: null,
      selectedItem: 1,
      items: [
        { text: "Real-Time" },
        { text: "Audience" },
        { text: "Conversions" },
      ],
      show_tab: false,
      alldemands: null,
      rdv_demands: [],
      current_user: null,

      activePicker: null,
      date: null,
      menu: false,
    };
  },
  created() {
    this.$store.dispatch("setCurrentRoute", this.$route.name);
    moment.locale(this.langLocal);
    this.getRdvDemands();
  },
  computed: {
    getLocaleMessages() {
      return this.$root.$i18n.messages[this.$root.$i18n.locale];
    },

    allowedDates() {
      return (val) => this.available_day.includes(new Date(val).getDay());
    },

    dateErrors() {
      const errors = [];
      if (!this.$v.date.$dirty) return errors;
      !this.$v.date.required &&
        errors.push(this.getLocaleMessages["date_require"]);
      return errors;
    },
    hoursErrors() {
      const errors = [];
      if (!this.$v.hours.$dirty) return errors;
      !this.$v.hours.required &&
        errors.push(this.getLocaleMessages["time_require"]);
      return errors;
    },
    ...mapGetters([
      "current_route",
      "langLocal",
      "authenticated",
      "user",
      "demands",
    ]),
  },
  methods: {
     formatDate(str) {
      return moment(str).subtract(0, "hour").format("L LTS");
    },
    async getRdvDemands() {
      await this.$store
        .dispatch("getRdvDemands")
        .then((response) => {
          if (response.data) {
            this.rdv_demands = response.data;
          }
          this.overlay = false;
          this.waiting_dialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async takeRdv() {
      this.isLoading = true;
      const data = new FormData();
      data.append("date_rdv", this.date);
      data.append("heure", this.hours);
      data.append("code", this.current_item.code_demande);
      data.append("unite", this.current_item.unite);
      await this.$store
        .dispatch("takRdvDemands", data)
        .then((response) => {
          this.isLoading = false;
          if (response.data.message == this.getLocaleMessages["no_date"]) {
            this.snackbar = true;
            this.snackbarColor = "red";
            this.snackbar_text = this.getLocaleMessages["no_rdv"];
          } else {
            this.can_get_rdv = false;
            this.snackbar = true;
            this.snackbarColor = "green";
            this.snackbar_text = this.getLocaleMessages["takesucess_rdv"];
            this.getRdvDemands();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getRdvHours() {
      const formdata = new FormData();
      formdata.append("code", this.current_item.code_demande);
      await this.$store
        .dispatch("getRdvHours", formdata)
        .then((response) => {
          if (response.data) {
            this.available_day = response.data.jours_ouvrable;

            this.available_hours = response.data.heuredispo.map((arr) => ({
              value: arr,
              name: arr,
            }));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDemandById(code) {
      let demand = this.rdv_demands.filter(function (element) {
        return element.code_demande == code;
      });
      return demand;
    },

    getColor(statut) {
      if (statut.toLowerCase() == "valide") return "#34ad54";
      else if (statut.toLowerCase() == "pending") return "orange";
      else if (statut.toLowerCase() == "complement") return "#06a3da";
      else return "red";
    },

    getColorAttribut(statut) {
      if (statut.toLowerCase() == "valide") return "green";
      else if (statut.toLowerCase() == "pending") return "orange";
      else if (statut.toLowerCase() == "complement") return "info";
      else return "red";
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
  watch: {
    can_get_rdv(val) {
      if (val == true) {
        this.getRdvHours();
      } else {
        this.hours = null;
        this.Date = null;
      }
    },
    langLocal(val) {
       moment.locale(val);
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "DAY"));
    },

    group() {
      this.drawer = false;
    },
    tab(val) {
      console.log(val);
    },
  },
};
</script>
<style>
.date {
  font-size: 20px;
}

v-card__subtitle,
.v-card__text,
.v-card__title {
  padding-bottom: 2px !important;
}

@media (max-width: 700px) {
}
</style>
